module.exports = __webpack_public_path__ + "img/4.08b4344c.png";